import script from "./MarketTypeTab.vue?vue&type=script&lang=ts&setup=true"
export * from "./MarketTypeTab.vue?vue&type=script&lang=ts&setup=true"

import "./MarketTypeTab.vue?vue&type=style&index=0&id=00634618&scoped=true&lang=scss"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/webtrade_prod_deploy/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00634618"]])

export default __exports__